export default function () {
  return {
    pageinfoLoading: false,
  }
}
